import {Platform, TextInput} from "react-native"
import React, {useRef} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"

const pickLonger = (firstValue, secondValue) => {
  if (firstValue == null) return secondValue
  if (secondValue == null) return firstValue

  return firstValue.length >= secondValue.length ? firstValue : secondValue
}

export default memo(shapeComponent(class ComponnetsUtilsInputFieldOptimised extends ShapeComponent {
  static propTypes = {
    stateComponent: PropTypes.object,
    stateName: PropTypes.string
  }

  setup() {
    this.inputRef = useRef()
  }

  render() {
    const {onChange, onChangeText, stateComponent, stateName, ...restProps} = this.props
    const inputProps = {
      onChangeText: this.tt.onChangeText,
      ref: this.inputRef
    }

    if (Platform.OS == "web") {
      inputProps.onChange = this.tt.onChange
    }

    return (
      <TextInput {...inputProps} {...restProps} />
    )
  }

  onChangeText = (newValue) => {
    const {onChangeText, stateComponent, stateName} = this.props

    this.lastValue = newValue

    if (stateComponent && stateName) {
      stateComponent.state[stateName] = newValue
    }

    if (onChangeText) {
      onChangeText(newValue)
    }
  }

  onChange = (event) => {
    const {onChange} = this.props
    const targetValue = event?.target?.value
    const currentTargetValue = event?.currentTarget?.value
    const nativeTargetValue = event?.nativeEvent?.target?.value
    const nativeValue = event?.nativeEvent?.text
    let newValue = targetValue ?? currentTargetValue ?? nativeTargetValue ?? nativeValue
    const inputType = event?.nativeEvent?.inputType
    const refValue = this.inputRef?.current?.value

    newValue = pickLonger(newValue, nativeValue)
    newValue = pickLonger(newValue, currentTargetValue)
    newValue = pickLonger(newValue, nativeTargetValue)
    newValue = pickLonger(newValue, refValue)

    if (this.lastValue && newValue && newValue.length == 1 && inputType?.startsWith("insert")) {
      newValue = `${this.lastValue}${newValue}`
    }

    if (this.lastValue && newValue && newValue.length < this.lastValue.length) {
      newValue = this.lastValue
    }

    if (newValue != null && newValue !== this.lastValue) {
      this.tt.onChangeText(newValue)
    }

    if (onChange) {
      onChange(event)
    }
  }
}))
